import React from 'react';
import FitFinder from '../../../components/FitFinder/FitFinder';

export default (props) => {
    const { pageType, deviceType } = props;
    return <FitFinder interactiveVizNav={props} pageType={pageType} deviceType={deviceType} />;
};
